// @flow
import React from 'react';

const displayDuration = (hours: number, minutes: number) => {
  let actualHours = hours;

  if (minutes && minutes > 0) {
    actualHours += minutes / 60;
  }

  if (actualHours === 1) {
    return '1 hour';
  }

  return `${String(actualHours)} hours`;
};

type Props = {
  hours?: number,
  minutes?: number,
};

const Duration = ({ hours = 0, minutes = 0 }: Props) => (
  <span>{displayDuration(hours, minutes)}</span>
);

export default Duration;



// WEBPACK FOOTER //
// ./src/modules/components/Duration.js